module.exports = __webpack_public_path__ + "img/menu_mega.8c6eaa58.jpg";